import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Navbar, ListGroup, ListGroupItem, Button, Collapse, Container } from 'reactstrap';
import { groupBy } from 'underscore';
import ReactGA from 'react-ga';
import Img from 'react-image';
import { FadeLoader } from 'react-spinners';

import { getPackage } from '../actions/PackageActions';
import noimage from "../assets/images/noimage.jpg";
import spbrand from"../assets/images/spbrand.svg";
import regrad from"../assets/images/re-grad.png";
import degrad from"../assets/images/de-grad.png";

class PackageResume extends React.Component {

	state = {
		arrCollapse: []
	}

	componentWillMount() {
		ReactGA.pageview('/CreaPackage/resume');
		this.props.getPackage();
	}

	_goBack() {
		this.props.history.goBack();
	}

	_goScreen(screen) {
		this.props.history.push(screen);
	}

	_toggleCollapse(i) {
		let arrCollapse = this.state.arrCollapse;
		arrCollapse[i] = !arrCollapse[i];
		this.setState({ arrCollapse });
	}

	_continue() {
		this.props.history.push('estimate');
	}

	_renderCount(size) {
		if (size > 0) {
			return <span> {' '} ({size})</span>
		}
		return <div></div>;
	}

	_renderSubItems(item) {
		if (item.list && item.list.length > 0) {
			return item.list.map((obj, i) => (
				<div className="sp-mark ">
					<div className="photoContainer" key={i} onClick={() => console.log(item.name, obj)}>
						<Img
							src={[obj.img, noimage]}
							loader={<FadeLoader color={'#462177'} loading={true} />}
						/>
					</div>
					<span className="sp-mark-label">
						<span>{obj.name}</span>
					<img alt="" src={degrad} />
					</span>
				</div>
			));
		}
		else return [];
	}

	_renderItems(items) {
		if (items.length > 0) {
			return items.map((obj, i) => (
				<div className="videoContainer" key={i}>
					<ListGroupItem onClick={() => this._toggleCollapse(i)}>
						<i className={"sp-ff ico-sp-cvright sp-orange " + (!this.state.arrCollapse[i] ? 'open' : '')}></i>
						{obj.name}
						{this._renderCount(obj.list.length)}
					</ListGroupItem>
					<Collapse isOpen={!this.state.arrCollapse[i]}>
						<div className="fred">
							{this._renderSubItems(obj)}
						</div>
						<div className="fred lk">
							<div className="sp-mark ">
								<div className="photoContainer">
									<Img
										src={[noimage]}
										loader={<FadeLoader color={'#462177'} loading={true} />}
									/>
								</div>
								<span className="sp-mark-label">
									<span>{obj.other}</span>
									<img alt="" src={degrad} />
								</span>
							</div>

						</div>
					</Collapse>
				</div>
			));
		}
		else return [];
	}

	render() {
		const { place, artistas, services } = this.props.package;
		let resume = [];

		if (place && place.name) {
			resume.push({ name: place.name, list: [place.spot] });
		} else {
			resume.push({ name: 'HOTELES', list: [], other: localStorage.getItem('otherPlace') });
		}
		
		if (artistas && artistas.length) {
			let obj = groupBy(artistas, 'category');
			for (let key in obj) {
				resume.push({ name: key, list: obj[key] });
			}
		} else {
			resume.push({ name: 'ARTISTAS', list: [], other: localStorage.getItem('otherArtist') });
		}

		if (services && services.length) {
			let obj = groupBy(services, 'category');
			for (let key in obj) {
				resume.push({ name: key, list: obj[key] });
			}
		} else {
			resume.push({ name: 'SERVICIOS', list: [], other: localStorage.getItem('otherService') });
		}

		return (
			<div className="sp-page">
				<Navbar className="sp-nav resumen">
					<div className="sp-label">
						<img src={spbrand} width="90" alt="logotipo" /> <img src={regrad} width="2" alt="" />
						Resumen
					</div>
					<div>&nbsp;</div>
				</Navbar>
				<div className="sp-content">
					<ListGroup className="sp-list ico">
						{this._renderItems(resume)}
					</ListGroup>
				</div>
				<div className="obj-home">
					<Container>
						<Button className="bt bt-primary m-t-30" onClick={() => this._continue()}>COTIZAR</Button>
					</Container>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({ package: state.PackageReducer.package });

export default withRouter(connect(mapStateToProps, { getPackage })(PackageResume));


// WEBPACK FOOTER //
// ./src/screens/PackageResume.js